<template>
    <hmenu></hmenu>

          <main>
            <section class="breadcrumb-height ns-breadcrumb-area" style="min-height: 300px; background-image: url('/assets/img/breadcrumb/breadcrumb-bg.jpg');" >
                <img src="/assets/img/breadcrumb/shape-1.png" alt="" class="ns-breadcrumb-shape-1">
                <img src="/assets/img/breadcrumb/breadcrumb-map.png" alt="" class="ns-breadcrumb-map">
                <img src="/assets/img/breadcrumb/shape-2.png" alt="" class="ns-breadcrumb-shape-2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="ns-breadcrumb-wrap text-center">
                                <h2 class="ns-breadcrumb-title">Menaxhimi i aksesit</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div class="ns-project-details-area pt-115 pb-70">
                <div class="container">

                    <div class="row">
                        <div class="col-xl-4 col-lg-5 col-md-5">
                            <div class="ns-project-details-img-2 w_img mb-40">
                                <img src="/asetet/pool.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-7 col-md-7">
                            <div class="ns-project-details-content mb-40">
                                <div class="ns-project-details-list">
                                    <h4>Zgjidhje për Kontroll të Aksesit në Pishina</h4>
                                    <p class="ns-project-details-text">Gpro ofron sisteme moderne dhe fleksibile për menaxhimin e aksesit në pishina, të përshtatura sipas nevojave të çdo biznesi apo kompleksi rekreativ. Sistemi mund të konfigurohet plotësisht sipas mënyrës së funksionimit që kërkon klienti. </p>
                                    <div>
                                      <h4>Funksionalitetet kryesore</h4>
                                      <ul>
                                          <li>1. Qasje njëpërdorimëshe për vizitorë.</li>
                                          <li>2. Qasje me abonime mujore ose sezonale.</li>
                                          <li>3. Qasje ditore dhe paketa familjare.</li>
                                          <li>4. Kontroll automatik i hyrjeve dhe daljeve.</li>
                                          <li>5. Menaxhim i anëtarëve dhe vizitorëve.</li>
                                          <li>6. Raporte të detajuara për hyrjet, përdorimin dhe statistikat.</li>
                                          <li>7. Integrim me turnstile, porta automatike dhe sisteme të pagesës.</li>
                                          <li>8. Softuer i avancuar në gjuhën shqipe.</li>
                                      </ul>
                                      <br>
                                      <br>
                                      <h4>Sistem i personalizuar sipas kërkesës</h4>
                                      <p class="ns-project-details-text">Çdo pishinë apo qendër rekreative ka nevoja të ndryshme. Gpro mund të zhvillojë logjikë dhe funksione specifike sipas mënyrës së punës së biznesit tuaj, duke ofruar fleksibilitet maksimal dhe menaxhim të lehtë.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-xl-8 col-lg-7 col-md-7">
                            <div class="ns-project-details-content mb-40">
                                <div class="ns-project-details-list">
                                    <h4>Zgjidhje Inteligjente për Qendra Fitnesi</h4>
                                    <p class="ns-project-details-text">Gpro ofron sisteme të avancuara për menaxhimin e qendrave të fitnesit, duke kombinuar kontrollin e aksesit, menaxhimin e abonimeve dhe raportimin në një platformë të vetme. </p>
                                    <div>
                                      <h4>Mundësi të ndryshme qasjeje</h4>
                                      <ul>
                                          <li>1. Qasje me QR Code.</li>
                                          <li>2. Qasje me kartela anëtarësimi.</li>
                                          <li>3. Qasje përmes telefonit mobil.</li>
                                          <li>4. Kontroll automatik i hyrjes së anëtarëve.</li>
                                          <li>5. Menaxhim i abonimeve mujore dhe vjetore.</li>
                                      </ul>
                                      <br>
                                      <br>
                                      <h4>Menaxhim i plotë i qendrës së fitnesit</h4>
                                      <ul>
                                          <li>1. Evidencë e anëtarëve aktivë.</li>
                                          <li>2. Raporte të ndryshme dhe statistika përdorimi.</li>
                                          <li>3. Menaxhim i pagesave dhe abonimeve.</li>
                                          <li>4. Shitje e produkteve të fitnesit dhe suplementeve.</li>
                                          <li>5. Evidencë e faturave dhe transaksioneve.</li>
                                          <li>6. Menaxhim i lehtë për stafin dhe administratorët.</li>
                                      </ul>
                                      <br>
                                      <br>
                                      <h4>Përshtatje sipas biznesit tuaj</h4>
                                      <p class="ns-project-details-text">Gpro ofron zgjidhje të personalizuara sipas kërkesave të klientit, duke bërë të mundur që sistemi të funksionojë saktësisht sipas nevojave dhe mënyrës së organizimit të qendrës suaj të fitnesit.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-5">
                            <div class="ns-project-details-img-2 w_img mb-40">
                                <img src="/asetet/fitnes.jpg" alt="">
                            </div>
                        </div>
                    </div>








                </div>
            </div>


        </main>


    <Footer></Footer>
</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    export default {

        data () {
            return {
               selected:'kioska'
            }
        },


        methods:{

            tabClick(type){
                this.selected = type
            }

        },

        mounted:function(){

        },


        components: {
            hmenu,
            Footer,
         
        },


        mounted:function(){
            window.scrollTo({top: 0, behavior: 'smooth'});
        }


    }

</script>

